import { render } from "./NSWI.vue?vue&type=template&id=81ab35ec"
import script from "./NSWI.vue?vue&type=script&lang=js"
export * from "./NSWI.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__